/**
* QuestionController
* @namespace gplans.survey.controllers
*/
(function () {
  'use strict';QuestionController.$inject = ["$rootScope", "$scope", "$http", "$window", "$localStorage", "$state", "$stateParams", "gplansConf", "Survey", "Authentication", "User", "$timeout", "UserService"];

  angular.
  module('gplans.survey.controllers').
  controller('QuestionController', QuestionController);

  QuestionController.$inject = ['$rootScope', '$scope', '$http', '$window', '$localStorage', '$state', '$stateParams',
  'gplansConf', 'Survey', 'Authentication', 'User', '$timeout', 'UserService'];

  /**
                                                                                * @namespace QuestionController
                                                                                */
  function QuestionController($rootScope, $scope, $http, $window, $localStorage, $state, $stateParams, gplansConf,
  Survey, Authentication, User, $timeout, UserService) {
    var vm = this;
    vm.answersChoiceId = [];
    vm.answer = {};
    activate();

    function afterSubmitAnswer(data) {
      // todo: move to Survey Service
      vm.answer = data.data;
      if (vm.questionNumber >= Survey.questions.length) {
        vm.finishSurvey();
      } else {
        vm.nextQuestion();
      }
      $scope.$parent.fetchUserSurveyAnswers();
    }

    vm.submitAnswer = function (_answer) {
      var answer = {
        answer_choice: _answer.id,
        question: _answer.question };

      vm.submitting = 1;
      $rootScope.quizChanged = true;

      var url = gplansConf.API_URL + '/api/v1/usersurveys/' + $scope.$parent.usersurvey.id + '/surveyanswers/',
      method = 'post';
      if (vm.answer.id && vm.questionNumber != 15) {
        url += vm.answer.id + '/';
        method = 'put';
      }
      if (vm.answersOld.length) {
        var oneOfAnswersOld = vm.answersOld[0];
        $http.delete(gplansConf.API_URL + '/api/v1/usersurveys/' + $scope.$parent.usersurvey.id + '/surveyanswers/' + oneOfAnswersOld.id + '/').then(
        function (res) {
          vm.answersOld = [];
          $http[method](url, vm.answer).then(function (data) {
            afterSubmitAnswer(data);
          });
        });
      } else
      {
        $http[method](url, answer).then(function (data) {
          afterSubmitAnswer(data);
        });
      }
    };

    /**
       * @name activate
       * @desc Actions to be performed when this controller is instantiated
       * @memberOf gplans.survey.controllers.QuestionController
       */
    function activate() {
      vm.questionNumber = Number($stateParams.question);
      vm.question = Survey.questions[vm.questionNumber - 1];
      vm.progress = vm.questionNumber / Survey.questions.length * 100;
      vm.progress = vm.progress > 100 ? 100 : vm.progress;
      vm.progressStyle = { "width": vm.progress + '%' };
      vm.quizLen = Survey.questions.length;
      vm.user = User;
    }


    vm.goBack = function () {
      $window.history.back();
    };

    function getLastQuestionAnswers() {
      vm.answersOld = [];
      if (vm.questionNumber == vm.quizLen) {
        for (var i = 0; i < $scope.userSurveyAnswers.length; i++) {
          // todo:refactor hardcode
          if ($scope.userSurveyAnswers[i].question == 15) {
            vm.answersOld.push({
              answer_choice: $scope.userSurveyAnswers[i].answer_choice,
              question: $scope.userSurveyAnswers[i].question,
              id: $scope.userSurveyAnswers[i].id });

            for (var j = 0; j < vm.question.choices.length; j++) {
              if (vm.question.choices[j].id == $scope.userSurveyAnswers[i].answer_choice) {
                vm.question.choices[j].checked = true;
              }
            }
          }
        }
      }
      return vm.answersOld;
    }

    vm.getLastQuestionObjs = function () {
      vm.answers = [];
      vm.answersChoiceId = [];
      for (var i = 0; i < vm.question.choices.length; i++) {
        if (vm.question.choices[i].checked && vm.question.choices[i].id != 41) {
          vm.answers.push({ answer_choice: vm.question.choices[i].id, question: vm.question.id });
          vm.answersChoiceId.push(vm.question.choices[i].id);
        }
      }
      if (vm.answers.length) vm.answer.answer_choice = null;
      return vm.answers;
    };

    function afterSubmitAnswersLastQuestion(data) {
      // todo: move to Survey Service
      vm.answer = data.data;
      vm.finishSurvey();
      $scope.$parent.fetchUserSurveyAnswers();
    }

    vm.submitAnswersLastQuestion = function () {
      vm.submitting = 1;
      $rootScope.quizChanged = true;
      vm.getLastQuestionObjs();
      var url = gplansConf.API_URL + '/api/v1/usersurveys/' + $scope.$parent.usersurvey.id + '/surveyanswers/',
      method = 'post';
      if (vm.answersOld.length) {
        var oneOfAnswersOld = vm.answersOld[0];
        $http.delete(gplansConf.API_URL + '/api/v1/usersurveys/' + $scope.$parent.usersurvey.id + '/surveyanswers/' + oneOfAnswersOld.id + '/').then(
        function (res) {
          vm.answersOld = [];
          vm.answer = null;
          $http[method](url, vm.answers).then(function (data) {
            afterSubmitAnswersLastQuestion(data);
          });
        });
      } else

      $http[method](url, vm.answers).then(function (data) {
        afterSubmitAnswersLastQuestion(data);
      });
    };


    $scope.$watch('userSurveyAnswers', function (newVal, oldVal) {
      // todo: move to Survey Service
      if (vm.question && typeof newVal !== 'undefined') {
        vm.answer = { question: vm.question.id };
        for (var i = 0; i < $scope.userSurveyAnswers.length; i++) {
          var ans = $scope.userSurveyAnswers[i];
          if (ans.question === vm.question.id) {
            vm.answer = ans;
          }
        }
        vm.answersOld = getLastQuestionAnswers();
      }
    });

    vm.finishSurvey = function () {
      $http.post(gplansConf.API_URL + '/api/v1/nutritionist/actions/RegenerateUserMealPlanAction/execute/',
      { 'email': UserService.data.email }).
      then(function (res) {
        $state.go('gplans.userConsole.overview', {}, { reload: true });
        vm.submitting = 0;
      }).catch(function (err) {
        vm.submitting = 0;
      });
    };

    vm.finishSurveyOld = function () {
      // we've finished quiz, so clear bloodType if we have it
      delete $localStorage.bloodTypeResult;

      if ($window.gplansStorage.gender &&
      $window.gplansStorage.age && $window.gplansStorage.current_weight &&
      $window.gplansStorage.goal_weight && !$window.gplansStorage.skipWeightForm) {
        $state.go('base.calculate', { userSurvey: $scope.$parent.usersurvey.id });
      } else {
        $state.go('survey.weight_age_form');
      }
    };

    vm.nextQuestion = function (nextQuestion) {
      vm.submitting = 0;
      if (vm.answer.answer_choice) {
        if (nextQuestion) {
          Survey.questions.some(function (q, index) {
            if (q.id === nextQuestion) {
              vm.questionNumber = index;
              return true;
            }
            return false;
          });
        }
        if ($rootScope.offerId) {
          $state.go('survey.question', { question: vm.questionNumber + 1 });
        } else {
          $timeout(function () {
            $state.go('survey.question', { question: vm.questionNumber + 1 });
          }, 1000);
        }
      }
    };

    vm.prevQuestion = function () {
      $state.go('survey.question', { question: vm.questionNumber - 1 });
    };

    vm.seeResults = function () {
      $state.go('base.complete', { userSurvey: $localStorage.userSurvey });
    };
  }
})();